import { isQuickChat } from 'productLine';

export interface QuickChatControlProps {
  children: JSX.Element | null;
}

// 在使用tabs.pane, menu.item等组件的时候，不能使用QuickChatControl包裹，否则会导致组件无法渲染
export const QuickChatControl = (props: QuickChatControlProps) => {
  if (isQuickChat) return <></>;

  return <>{props.children}</>;
};
